import React from 'react';

import { Box, Typography, Button } from '@mui/material';
import { FormattedMessage } from 'react-intl';
import { Link } from 'react-router-dom';

import Carousel from './components/Carousel';
import TestimonialCard from './components/TestimonialCard';

import {
  generateTestimonialsDataStructure,
  testimonialsES,
} from 'views/Testimonials/utils';

const testimonials = generateTestimonialsDataStructure(testimonialsES);
function Testimonials() {
  return (
    <Box
      sx={{
        overflowX: 'hidden',
        paddingY: {
          xs: 5,
        },
      }}
    >
      <Box>
        <Typography
          align={'center'}
          sx={{
            textTransform: 'uppercase',
            fontWeight: 700,
          }}
          gutterBottom
          color={'primary'}
        >
          <FormattedMessage id={'landing.testimonials.title1'} />{' '}
        </Typography>
        <Typography
          variant={'h3'}
          marginBottom={{ xs: 5, md: 5 }}
          align={'center'}
          sx={{ fontWeight: 700 }}
          gutterBottom
        >
          <FormattedMessage id={'landing.testimonials.title2'} />
        </Typography>
      </Box>
      <Carousel>
        {testimonials.map((testimonial) => {
          return (
            <TestimonialCard
              testimonial={testimonial}
              key={crypto.randomUUID()}
            />
          );
        })}
      </Carousel>
      <Box display="flex" justifyContent="center" mt={6}>
        <Button
          component={Link}
          to="/testimonials"
          variant="contained"
          sx={{
            backgroundColor: 'primary.main',
            color: 'white',
            textDecoration: 'none',
            '&:hover': {
              backgroundColor: 'primary.dark',
              textDecoration: 'none',
            },
          }}
        >
          <FormattedMessage id={'landing.testimonials.cta'} />
        </Button>
      </Box>
    </Box>
  );
}

export default Testimonials;
